<template>
<div>
  <table border='1' cellspacing='0' cellpadding='4' v-for="(pageChunk,pi) in pages" :key="pi">
    <thead>
      <tr>
        <th class='print-logo' colspan='5'><img :src="logo"/></th>
        <th :colspan="maxOutcomesPerPage" v-html="t('PrintOdds.HeaderText')"></th>
      </tr>
      <tr>
        <th colspan='5'>{{sportName}}</th>
        <th v-for="(marketName,mni) in pageChunk.marketNames" :colspan='marketName.colSpan' :key="mni">
          {{marketName.name}}
        </th>
      </tr>
      <tr>
        <th>{{t('Public.Code')}}</th>
        <th>{{t('Public.Time')}}</th>
        <th>{{t('PrintOdds.League')}}</th>
        <th>{{t('PrintOdds.HomeTeam')}}</th>
        <th>{{t('PrintOdds.AwayTeam')}}</th>
        <th v-for="(pageColumn,pco) in pageChunk.page" :key="pco">{{pageColumn.outcomeName}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(match,mi) in pageChunk.matchesWithOutcomes" :key="mi">
        <td>{{match.eventCode}}</td>
        <td>{{match.date}} {{match.time}}</td>
        <td>{{tournamentName}}</td>
        <td>{{match.homeTeam}}</td>
        <td>{{match.guestTeam}}</td>
        <td v-for="(outcome,moi) in match.matchOdds" :key="moi">{{outcome | formatOddDisplay}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
  export default {
    name: 'PrintPage',
    props: {
      pages: {
        type: Array,
        required: true,
      },
      maxOutcomesPerPage: {
        type: Number,
        required: true,
      },
      sportName: {
        type: String,
        required: true,
      },
      tournamentName: {
        type: String,
        required: true,
      },
      logo: {
        type: HTMLImageElement,
        required: true,
      }
    },
  };
</script>